import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  Avatar,
  Card,
  CardContent,
  CardHeader,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { API_BASE_URL } from "../../../apiConfig";
import axios from "axios";
import StoreCard from "./StoreCard";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  borderRadius: "5px",
  boxShadow: 24,
  p: 0.5,
};

export default function StoreModal({ carId, onClose }) {
  const [carData, setCarData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setError(null);
      try {
        const response = await axios.get(`${API_BASE_URL}Store/Find/${carId}`);
        setCarData(response.data);
      } catch (err) {
        setError("Failed to fetch store data");
      }
    };
    fetchData();
  }, [carId]);

  return (
    <Modal open={true} onClose={onClose} aria-labelledby="modal-title">
      <Box sx={style}>
        <Card>
          <CardHeader
            action={
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            }
            sx={{ textAlign: "center" }}
          />
          <StoreCard carId={carId} />
        </Card>
      </Box>
    </Modal>
  );
}
